let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cDrmL")).then(() => parcelRequire('j7DuR'));